// import React, { useState, useEffect } from 'react';
// import '../competitive/../header/style.css';
// //import './styles.css';
// import { Header } from "../competitive";
// import { Adminmain, AdminNavbar } from "../competitive";
// import { Link, useNavigate } from "react-router-dom";
// import axios from 'axios';
// import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url } from '../../../constants/apiConstants';
// function CompetitiveListRole() {
//     const navigate = useNavigate();
//     const [errors, setErrors] = useState({});
//     const [role, setRole] = useState([]); // State to hold roles data


//     useEffect(() => {
//         const url = API_BASE_URL + '/getAdminRoleData';
    
//         const fetchRoles = async () => {
//             try {
//                 const response = await axios.get(url, {
//                     headers: {
//                         "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`, // Replace with your actual token
//                         "Content-Type": "application/json",
//                     },
//                 });
//                 console.log(response.data);
//                 setRole(response.data); // Set roles data to state
//                 console.log(role);
//             } catch (err) {
//                 console.error(err); // Handle error
//             }
//         };
    
//         fetchRoles(); // Call the fetch function
//     }, []); // Empty dependency array to run only on mount
    
//     const handelDelete = async (id) => {
//         console.log("id : -", id);
    
//         axios
//             .delete(API_BASE_URL + '/deleteRoleDataById/' + id, {
//                 headers: {
//                     "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`, // Replace with your actual token
//                     "Content-Type": "application/json",
//                 },
//             })
//             .then(function (response) {
//                 if (response.status === 200) {
//                     setRole(role.filter((item) => item.id !== id));
//                     navigate("/admin/listRole");
//                 } else {
//                     // Handle other status codes if needed
//                 }
//             })
//             .catch(function (error) {
//                 console.error(error);
//             });
//     };
    
//     return (
//         <div>
//             <Header />
//             <div className="main-container">
//                 <AdminNavbar />
//                 {/* <Adminmain /> */}
//                 <div className="main">
//                     <div className="report-container">
//                         <div className="report-header">
//                             <h1 className="recent-Articles"> Competitive List</h1>
//                             <Link class="recent-Articles" to={`/admin/competitiveCreateRole`}> Create New Competitive Exam</Link>
//                         </div>

//                         <div className="report-body">
//                             <table className="table table-striped">
//                                 <thead>
//                                     <tr>
//                                         <th>Participating Colleges</th>
//                                         <th>Exam Date</th>
//                                         <th>Exam Level</th>
//                                         <th>Application Process</th>
//                                         <th>Exam Info</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>

//                                     {role.map((item, i) => (
//                                         <tr key={item.id}>
//                                             <td>{i + 1}</td>
//                                             <td>{item.role_name}</td>
//                                             <td>{item.status}</td>
//                                             <td>
//                                                 <Link to={`/admin/editCompetitiveRole/${item.id}`}>
//                                                     <i className="fa fa-pencil" aria-hidden="true"></i>
//                                                 </Link>

//                                                 <i
//                                                     className="fa fa-trash-o"
//                                                     aria-hidden="true"
//                                                     onClick={() => handelDelete(item.id)}
//                                                 ></i>
//                                             </td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </table>
//                             {/* <div className="report-topic-heading">
//                                 <h3 className="t-op">Article</h3>
//                                 <h3 className="t-op">Views</h3>
//                                 <h3 className="t-op">Comments</h3>
//                                 <h3 className="t-op">Status</h3>
//                             </div>

//                             <div className="items">
//                                 <div className="item1">
//                                     <h3 className="t-op-nextlvl">Article 73</h3>
//                                     <h3 className="t-op-nextlvl">2.9k</h3>
//                                     <h3 className="t-op-nextlvl">210</h3>
//                                     <h3 className="t-op-nextlvl label-tag">Published</h3>
//                                 </div>
//                             </div> */}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default CompetitiveListRole;



import React, { useState, useEffect } from 'react';
import '../competitive/../header/style.css';
import { Header } from "../competitive";
import { AdminNavbar } from "../competitive";
import { Link, useNavigate } from "react-router-dom";
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME } from '../../../constants/apiConstants';

function CompetitiveListRole() {
    const navigate = useNavigate();
    const [roleList, setRoleList] = useState([]); // State to hold competitive exam data

    useEffect(() => {
        fetchRoles();
    }, []);

    const fetchRoles = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/getcompetitiveExamsData`, {
                headers: {
                    "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
                    "Content-Type": "application/json",
                },
            });
            setRoleList(response.data); // Store response data in state
        } catch (err) {
            console.error("Error fetching roles:", err);
        }
    };

    const handleDelete = async (id) => {
        try {
            const response = await axios.delete(`${API_BASE_URL}/deleteRoleDataById/${id}`, {
                headers: {
                    "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
                    "Content-Type": "application/json",
                },
            });

            if (response.status === 200) {
                setRoleList(roleList.filter((item) => item.id !== id)); // Remove deleted item from the list
            }
        } catch (error) {
            console.error("Error deleting role:", error);
        }
    };

    return (
        <div>
            <Header />
            <div className="main-container">
                <AdminNavbar />
                <div className="main">
                    <div className="report-container">
                        <div className="report-header">
                            <h1 className="recent-Articles">Competitive Exam List</h1>
                            <Link className="recent-Articles" to={`/admin/competitiveCreateRole`}>
                                Create New Competitive Exam
                            </Link>
                        </div>

                        <div className="report-body">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        {/* <th>Competitive Exam Name</th>
                                        <th>Competitive Exam Title</th> */}
                                        <th>PDCET</th>
                                        <th>Participating Colleges</th>
                                        <th>Exam Date</th>
                                        <th>Exam Level</th>
                                        <th>Application Process</th>
                                        <th>Exam Info</th>
                                        <th>Status</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {roleList.length > 0 ? (
                                        roleList.map((item, index) => (
                                            <tr key={item.id}>
                                                <td>{index + 1}</td>
                                                {/* <td>{item.role_name}</td>
                                                <td>{item.title}</td> */}
                                                <td>{item.pdcet}</td>
                                                <td>{item.participating_colleges}</td>
                                                <td>{item.exam_date}</td>
                                                <td>{item.exam_level}</td>
                                                <td>{item.application_process}</td>
                                                <td>{item.exam_info}</td>
                                                <td>{item.status === "1" ? "Active" : "Inactive"}</td>
                                                <td>
                                                    <Link to={`/admin/editCompetitiveRole/${item.id}`}>
                                                        <i className="fa fa-pencil" aria-hidden="true"></i>
                                                    </Link>

                                                    <i
                                                        className="fa fa-trash-o"
                                                        aria-hidden="true"
                                                        onClick={() => handleDelete(item.id)}
                                                    ></i>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="10" className="text-center">
                                                No records found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div> 
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CompetitiveListRole;
